import React from 'react'
import { AdminPropertyAd } from 'types'
import { Box, SvgIcon, Button } from '@mui/material'
import { ReactComponent as PhoneSvg } from 'assets/svg/new-icons/phoneblack.svg'
import { ReactComponent as EmailSvg } from 'assets/svg/new-icons/emailblack.svg'
import ListingDelete from './ListingDelete'
import ListingLink from './ListingLink'
import ListingAgentLink from './ListingAgentLink'

interface Props {
  propertyAd: AdminPropertyAd
  isExpanded: boolean
  onDelete: () => void
  onPrevent: (e: React.MouseEvent) => void
  listId: number | null
  matchesSM: boolean
  matchesTablet: boolean
  listName: string
}
function ListingActions(props: Props) {
  const {
    propertyAd,
    isExpanded,
    onDelete,
    listId,
    onPrevent,
    matchesSM,
    matchesTablet,
    listName,
  } = props

  return (
    <Box
      sx={{
        width: matchesSM ? '100%' : '128px',
        display: 'flex',
        flexDirection: matchesSM ? 'row' : 'column',
        justifyContent: { xs: 'space-between', sm: 'flex-end' },
        alignItems: matchesSM ? 'center' : 'flex-end',
        gap: '23px',
      }}
    >
      {matchesSM && !isExpanded ? null : (
        <Box
          sx={{
            float: 'right',
            width: 'fit-content',
            display: 'flex',
            justifyContent: 'flex-end',
            flexDirection: 'row',
            alignItems: 'baseline',
            gap: 3,
          }}
          onClick={onPrevent}
        >
          <Box sx={{ alignSelf: 'flex-end' }}>
            <ListingLink
              propertyAd={propertyAd}
              matchesTablet={matchesTablet}
            />
          </Box>
          {matchesSM ? null : (
            <ListingDelete
              listName={listName}
              listId={listId}
              propertyAd={propertyAd}
              onDelete={onDelete}
              isExpanded={isExpanded}
            />
          )}
        </Box>
      )}

      {isExpanded ? (
        <>
          <ListingAgentLink matchesSM={matchesSM} propertyAd={propertyAd} />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'no-wrap',
              justifyContent: 'flex-end',
              columnGap: { xs: '8px', sm: '18px' },
            }}
          >
            <Button
              onClick={() => {
                const phoneNumber =
                  propertyAd?.agentCInfo?.mobileNumber ||
                  propertyAd?.agentCInfo?.landLineNumber ||
                  propertyAd?.agentCInfo?.landLineNumber2

                if (phoneNumber) window.open(`tel:${phoneNumber}`)
              }}
              sx={{
                minWidth: '50px',
                minHeight: '50px',
                border: {
                  xs: 'none',

                  md: '1px solid #EBEBEB',
                },
                borderRadius: '12px',
                boxShadow: {
                  xs: 'none',
                  md: '3px 3px 8px rgba(9, 9, 9, 0.3)',
                },
                '&:hover': { bgcolor: 'transparent' },
              }}
            >
              <SvgIcon
                component={PhoneSvg}
                inheritViewBox
                sx={{ width: '16px', height: '21px' }}
              />
            </Button>
            <Button
              onClick={() => {
                if (propertyAd?.agentCInfo?.email !== '')
                  window.open(`mailto:${propertyAd?.agentCInfo?.email}`)
              }}
              sx={{
                p: { xs: '4px', sm: 'default' },
                minWidth: { xs: '21px', md: '50px' },
                minHeight: { xs: '21px', md: '50px' },
                border: { xs: 'none', md: '1px solid #EBEBEB' },
                borderRadius: '12px',
                boxShadow: {
                  xs: 'none',
                  md: '3px 3px 8px rgba(9, 9, 9, 0.3)',
                },
                '&:hover': { bgcolor: 'transparent' },
              }}
            >
              <SvgIcon
                component={EmailSvg}
                inheritViewBox
                sx={{ width: '28px' }}
              />
            </Button>
          </Box>
        </>
      ) : (
        ''
      )}
    </Box>
  )
}

export default ListingActions
